import React from "react";
import type { ExcelFunctionMeta } from "@os/utils/excelFunctions";

type Props = {
  items: ExcelFunctionMeta[];
  highlightIndex?: number;
  onSelect: (item: ExcelFunctionMeta) => void;
};

const FormulaSuggestions: React.FC<Props> = ({ items, highlightIndex = 0, onSelect }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="absolute left-0 right-0 top-full mt-1 z-50 rounded-md border border-border bg-popover shadow-lg">
      <ul className="max-h-56 overflow-auto py-1">
        {items.map((item, idx) => {
          const active = idx === highlightIndex;
          return (
            <li
              key={`${item.name}-${idx}`}
              onMouseDown={(e) => {
                e.preventDefault();
                onSelect(item);
              }}
              className={`px-3 py-2 text-sm cursor-pointer flex items-start gap-2 ${
                active ? "bg-muted" : "hover:bg-muted/60"
              }`}
            >
              <span className="font-medium text-foreground">{item.name}</span>
              {item.signature ? (
                <span className="text-muted-foreground truncate">{item.signature}</span>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FormulaSuggestions;